module.exports = __webpack_public_path__ + "static/media/howtobefat_img_7.a7787f16.png";